import { Flex, Switch } from '@chakra-ui/react'

import { FormField } from '../../../components/FormField'
import { Icon } from '../../../components/Icon'
import { MoneyInput } from '../../../components/MaskedInput'
import { Tooltip } from '../../../components/Tooltip'

/** O mínimo do site para ingresso pago, que a API também cobra do preço na porta. */
const DOOR_PRICE_MIN = 5

const DOOR_SALE_INFO =
  'Permite vender este ingresso pelo app de check-in (na maquininha ou no celular) durante o evento. ' +
  'O preço na porta é o valor final: não soma a taxa de 10% e não aceita cupom. ' +
  'O estoque (Quantidade) é compartilhado com o site. ' +
  'O máximo por compra e o período de vendas do site não valem na porta. ' +
  'Um ingresso oculto (Visível desligado) também é vendido na porta; para ele ser só da porta, ' +
  'encerre também o período de vendas do site.'

export interface IDoorSaleTicketPatch {
  sell_at_door?: boolean
  door_price?: number | null
}

interface IProps {
  /** Prefixo dos ids dos controles (`ticket-0`, `template-0`). */
  idPrefix: string
  sellAtDoor: boolean
  doorPrice: number | null
  /** Erro do preço na porta vindo da API. */
  error?: string
  saving: boolean
  onChange: (patch: IDoorSaleTicketPatch) => void
}

/**
 * "Vender na porta" e "Preço na porta" de um ingresso pago (ABRA-319), iguais no formulário do
 * evento e no da série. Desligar a opção não apaga o preço: a API o guarda para quando ela voltar.
 */
export function DoorSaleTicketFields({ idPrefix, sellAtDoor, doorPrice, error, saving, onChange }: IProps) {
  const belowMinimum = doorPrice !== null && doorPrice < DOOR_PRICE_MIN

  return (
    <Flex gap={3} alignItems="flex-start" wrap="wrap">
      <FormField
        label={
          <>
            Vender na porta
            <Tooltip label={DOOR_SALE_INFO}>
              <Icon name="lni lni-information" size="sm" color="gray.400" cursor="help" ml={1.5} />
            </Tooltip>
          </>
        }
        htmlFor={`${idPrefix}-sell_at_door`}
        flex="1"
        mb={0}
      >
        <Switch
          id={`${idPrefix}-sell_at_door`}
          isChecked={sellAtDoor}
          onChange={(e) => onChange({ sell_at_door: e.target.checked })}
          isDisabled={saving}
        />
      </FormField>
      {sellAtDoor && (
        <FormField
          label="Preço na porta"
          error={belowMinimum ? 'O preço na porta deve ser de pelo menos R$ 5,00.' : error}
          helperText={belowMinimum || error ? undefined : 'Valor final, sem taxa e sem cupom.'}
          isRequired
          flex="2"
          mb={0}
        >
          <MoneyInput
            size="sm"
            value={doorPrice}
            onChange={(price) => onChange({ door_price: price })}
            isDisabled={saving}
          />
        </FormField>
      )}
    </Flex>
  )
}
